/**
 * V2 API 路徑不存在時重新整理一次：只用於「pos-web 已退版、仍開著新版頁面、後端已退到沒有 V2 的版本」的復原，
 * 重新整理後載入舊版 bundle、改打舊 API。
 *
 * 只認 404：V2 端點都是需登入的 GET，已登入時舊後端對不認得的路徑回 404；401 一律是 session 問題，照原流程登出。
 * 是否套用由請求的 `reloadOnMissingRoute` 決定（Axios request config 的前端本地 metadata）。
 *
 * 本模組須維持零依賴（Vitest 直接載入，不得 import `@` 開頭的模組）。
 */

export const RELOAD_GUARD_KEY = 'posWeb:missingRouteReloadAt'
export const RELOAD_GUARD_MS = 5 * 60 * 1000

export function isMissingRouteResponse(reloadOnMissingRoute, status) {
	return reloadOnMissingRoute === true && status === 404
}

/**
 * 是否可以重新整理，可以的話同時記下時間戳記（RELOAD_GUARD_MS 內只重新整理一次，防止迴圈）。
 * storage 無法存取或寫入未生效時回 false：寧可走原本的錯誤流程，也不冒無窮重新整理的風險。
 *
 * @param {Storage} storage 一般傳 sessionStorage
 * @param {number} now
 * @returns {boolean}
 */
export function claimMissingRouteReload(storage, now) {
	try {
		const last = Number(storage.getItem(RELOAD_GUARD_KEY))
		if (last && now >= last && now - last < RELOAD_GUARD_MS) {
			return false
		}
		storage.setItem(RELOAD_GUARD_KEY, String(now))
		return storage.getItem(RELOAD_GUARD_KEY) === String(now)
	} catch (e) {
		return false
	}
}
